import { pdfjs } from 'react-pdf';

// pdf.js needs its worker URL set exactly once, before any <Document> renders. Both the offer page and
// the vivid-dashboard material viewer render PDFs, and either can be the first to mount, so the
// assignment lives here in a shared module both import rather than in one page that the other might not
// load. The worker file itself is copied into public/ by scripts/copy-pdf-worker.js on prestart/prebuild.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.${pdfjs.version}.min.mjs`;
